import React from 'react';
import Layout from 'components/layouts';
import ProgressBar from 'components/progress-bar';
import styles from './styles.module.scss';
import { Capacitor } from '@capacitor/core';
import { QUERY_KEYS } from '../../constants'; // API cache keys
import { useQuery } from 'react-query';
import { activityStats, getSurveysLink  } from 'api/user';
import { ActivityStatsResponse } from '../../types/user'; 
const Surveys: React.FC<any> = () => {

  // Check if running on native platform (e.g., mobile app)
  const isNative = Capacitor.isNativePlatform();

  // Use React Query to fetch user activity stats (managed by the header component)
  const { data: stats } = useQuery<ActivityStatsResponse>(
    [QUERY_KEYS.USER.ACTIVITY_STATS],
    activityStats,
    {
      enabled: false, // Only reads from cache, disable automatic refetching, rely on header component to manage refetching
    }
  );


  // Use react query to fetch survey iframe link (fetch only once)
  const { data: surveysLinkData, isLoading, isFetching, isSuccess} = useQuery<{surveys_link: string}>(
    [QUERY_KEYS.USER.SURVEYS_LINK],
    getSurveysLink,
    {
      staleTime: Infinity, // Data is considered fresh indefinitely
      cacheTime: Infinity, // Cache data indefinitely
      refetchOnWindowFocus: false, // Do not refetch when window gains focus
      refetchOnMount: false, // Do not refetch on component mount
      refetchOnReconnect: false, // Do not refetch on network reconnect
      keepPreviousData: true, // Keep previous data while fetching new data
      enabled: true, // Enable the query to run
      retry: (failureCount, error: any) => {
        const status = error?.status;
        // Retry 2 times if NOT one of these status codes
        return failureCount < 2 && ![400, 401, 404].includes(status);
      },
      retryDelay: () => 4000, // 4s delay before each retry
    }
  );
  
  const loading = isLoading || (isFetching && !isSuccess); // initial load or retries
  const finishedNoSuccess = !loading && !isSuccess;        // done and not successful
  const surveysLink = surveysLinkData?.surveys_link || null;

  const minEarningsToWithdraw = 20; // Minimum earnings required to enable withdrawal
  const currentEarnings = Number(stats?.earnings_sum || 0);
  const isReachedTarget = currentEarnings >= minEarningsToWithdraw; // If user reached the target, hide the progress bar

  return (
    <Layout hideFooter={isNative}>
      {/* Hide footer if runs on native app */}
      <div className={styles.wrapper}>
        <ProgressBar current={currentEarnings} target={minEarningsToWithdraw} hidden={isReachedTarget}/>
        <div className={styles.title}>Survey Offers</div>
        {/* Surveys Iframe, show only if iframe link exists */}
        {/* loading while fetching or retrying */}
        {loading && (
          <div>
            Loading…
          </div>
        )}
        {/* finished and not successful */}
        {finishedNoSuccess && (
          <div>
            We can't find any survey offers for you right now. Please contact support if this issue persists.
          </div>
        )}
        { surveysLink && (
          <iframe
            title="Surveys"
            src={surveysLink}
            style={{
              width: '100%',
              height: '800px',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              borderRadius: '12px',
            }}
          ></iframe>
        )}
      </div>
    </Layout>
  );
};

export default Surveys;
